import styles from './PartyTray.module.css';
import { useSubject } from "../../utils/contexts/SubjectContext";
import { scrollToIdWithOffset } from '../../lib/scrolling/ScrollToIdWithOffset';
import { useNavbarHeight } from '../../utils/contexts/NavbarContext';
import FadeInComponent from '../ui/FadeInComponent';

const partyTrayOptions = [
  { src: "/images/partyTray/spring-roll-1.webp", alt: "Spring roll party tray" },
  { src: "/images/partyTray/variety-1.webp", alt: "Variety party tray" },
  { src: "/images/partyTray/egg-roll-1.webp", alt: "Egg roll party tray" },
];

function PartyTray() {
  const { setSubject } = useSubject();
  const { navbarHeight } = useNavbarHeight();

  return (
    <section id="partyTray">
      <FadeInComponent className="container-fluid pt-4 pb-5 px-4">
        <div className="text-center my-heading">
          <h2>Party Trays</h2>
          <p>Party Trays made easy! Plenty of flavor, none of the stress.</p>
        </div>

        <div className={`row justify-content-center mt-5 mb-3 g-4 ${styles.partyTrayGrid}`}>
          {partyTrayOptions.map((option) => (
            <div key={option.src} className="col-12 col-md-6 col-lg-3">
              <img
                src={option.src}
                alt={option.alt}
                className={styles.partyTrayImage}
              />
            </div>
          ))}
        </div>

        <div className="w-100 text-center mt-4">
          <a
            href="#contactUs"
            className={`btn btn-alo ${styles.contactButton}`}
            onClick={(e) => {
              setSubject("Request for details on Party Tray");
              scrollToIdWithOffset("contactUs", e, navbarHeight);
            }}
          >
            Contact For Details
          </a>
        </div>
      </FadeInComponent>
    </section>
  );
}

export default PartyTray;